import { CustomInfo } from 'cb-unified';
import { selectUser } from 'gossamer-front-end';
import { Nav } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

export const ReportMenu = (): React.JSX.Element => {
  const lastPathElement = window.location.pathname.split('/').pop();
  const user = useSelector(selectUser);
  const canSeeGroups =
    user?.roleId === 'staff' ||
    (user?.roleId === 'admin' && (user.customInfo as CustomInfo)?.adminInstitutionType === 'enterprise');
  return (
    <Nav variant="underline" defaultActiveKey={lastPathElement}>
      <Nav.Link as="li" eventKey="inst-week-search">
        <Link to="../inst-week-search">Summary / Week</Link>
      </Nav.Link>
      {canSeeGroups && (
        <Nav.Link as="li" eventKey="group-week-search">
          <Link to="../group-week-search">Group / Week</Link>
        </Nav.Link>
      )}
      {canSeeGroups && (
        <Nav.Link as="li" eventKey="group-week-user-search">
          <Link to="../group-week-user-search">Group / Week / User</Link>
        </Nav.Link>
      )}
      <Nav.Link as="li" eventKey="user-week-search">
        <Link to="../user-week-search">User / Week</Link>
      </Nav.Link>
      <Nav.Link as="li" eventKey="event-search">
        <Link to="../event-search">Event Detail</Link>
      </Nav.Link>
      <Nav.Link as="li" eventKey="booking-search">
        <Link to="../booking-search">Booking Detail</Link>
      </Nav.Link>
      <Nav.Link as="li" eventKey="booking-export">
        <Link to="../booking-export">Bookings Export</Link>
      </Nav.Link>
    </Nav>
  );
};
